
import authConstant from '../constants/auth';

const loginAction = (user) => ({ type: authConstant.LOGIN_REQUEST, user });
const logOutAction = () => ({ type: authConstant.LOGOUT });

export {
  logOutAction,
  loginAction,
};
